/* TuinDepot — steen-PDP (td-steen.js) v1.6 · 2026-10-03 (keuzeknop 1 bigbag toont het gewicht zonder 'samen'; v1.5: keuzeknoppen 1–3 bigbags met staffelkorting + "Meer dan 3" → stepper; totaalprijs min de korting, ook in de rekenhulp; v1.4: prijs bovenaan volgt het aantal, geen transportberekening, rekenhulp met lengte × breedte · hoort bij sections/td-steen-*.liquid */
(function (G) {
  'use strict';

  /* ================= pure helpers (ook in node getest) ================= */
  function fmtMoney(c) {
    var v = (Math.round(c) / 100).toFixed(2).replace('.', ',');
    return '€' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  /* 4 cijfers zonder punt (1000 kg, zoals in de optienamen), vanaf 5 cijfers met punt (20.000 kg) */
  function fmtKg(kg) { var n = Math.round(kg); return (n >= 10000 ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') : String(n)) + ' kg'; }
  function parseKg(label) {
    var m = /(\d+(?:[.,]\d+)?)\s*kg/i.exec(label || '');
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* rekenhulp: per verpakking het aantal dat de behoefte dekt; voordeligste markeren */
  function calcOptions(needKg, list, maxKg, discFn) {
    var rows = [];
    list.forEach(function (x) {
      if (!(x.w > 0)) return;
      var qty = Math.max(1, Math.ceil(needKg / x.w - 1e-9)), kg = qty * x.w;
      if (maxKg && kg > maxKg + 1e-9) return;
      rows.push({ ref: x, qty: qty, kg: kg, total: qty * x.p - (discFn ? discFn(qty) : 0) });
    });
    rows.sort(function (a, b) { return a.ref.w - b.ref.w; });
    var best = null;
    rows.forEach(function (r) {
      if (!best || r.total < best.total || (r.total === best.total && (r.qty < best.qty || (r.qty === best.qty && r.kg < best.kg)))) best = r;
    });
    rows.forEach(function (r) { r.best = (r === best); });
    return rows;
  }

  var util = { fmtMoney: fmtMoney, fmtKg: fmtKg, parseKg: parseKg, calcOptions: calcOptions };
  if (typeof document === 'undefined') { if (typeof module !== 'undefined' && module.exports) module.exports = util; return; }
  if (G.TDSteen) { if (G.TDSteen.scan) G.TDSteen.scan(); return; }

  /* ================= DOM-deel ================= */
  var TD = G.TDSteen = { util: util, main: null, subs: [] };

  /* enkel nog het maximumgewicht per levering (uit de hoofdsectie); geen tarieven of postcodes meer */
  function getCfg() {
    var root = document.querySelector('[data-td-st-main]');
    var n = root ? parseFloat(root.getAttribute('data-maxkg')) : NaN;
    return { maxKg: isNaN(n) ? 0 : n };
  }
  function notify() {
    TD.subs.forEach(function (fn) { try { fn(TD.main); } catch (e) {} });
  }
  TD.onState = function (fn) { TD.subs.push(fn); if (TD.main) { try { fn(TD.main); } catch (e) {} } };

  /* ---------- hoofdsectie ---------- */
  function initMain(root) {
    if (root.__tds) return;
    var dEl = root.querySelector('[data-td-st-data]'), data;
    if (!dEl) return;
    try { data = JSON.parse(dEl.textContent); } catch (e) { return; }
    root.__tds = true;
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var pk = data.pk | 0, pv = data.pv | 0;
    var qcfg = parseInt(root.getAttribute('data-qmax'), 10) || 20;
    var showBest = root.getAttribute('data-best') === 'true';
    var V = data.variants.map(function (v) {
      var kk = pk ? v.o[pk - 1] : null, vv = pv ? v.o[pv - 1] : null;
      return { id: v.id, k: kk, v: vv, p: v.p, w: v.w > 0 ? v.w : parseKg(vv), a: v.a, m: v.m };
    });
    if (!V.length) return;
    var vidEl = q('[data-td-st-vid]'), qtyEl = q('[data-td-st-qty]'), numEl = q('[data-td-st-num]');
    /* keuzeknoppen 1..N bigbags + staffelkorting (bedragen gelijk aan de automatische kortingen in Shopify) */
    var qblk = q('[data-td-st-qtyblk]');
    var tiersN = qblk ? (parseInt(qblk.getAttribute('data-tiers'), 10) || 0) : 0;
    var discs = qblk ? (qblk.getAttribute('data-discs') || '').split(',').map(function (s) { return Math.round((parseFloat(s) || 0) * 100); }) : [];
    function discOf(n) { if (!discs.length) return 0; return discs[Math.min(n, discs.length) - 1] || 0; }
    var tierBtns = qa('[data-td-st-tier]'), moreBtn = q('[data-td-st-tier-more]'), stepRow = q('[data-td-st-stepper]');
    var cur0 = null;
    V.forEach(function (x) { if (vidEl && String(x.id) === String(vidEl.value)) cur0 = x; });
    cur0 = cur0 || V[0];
    var S = { k: cur0.k, v: cur0.v, qty: 1 };

    function pick(k, v) {
      for (var i = 0; i < V.length; i++) { var x = V[i]; if ((!pk || x.k === k) && (!pv || x.v === v)) return x; }
      return null;
    }
    function cur() { return pick(S.k, S.v) || V[0]; }
    function qmaxFor(w) {
      var t = getCfg(), m = qcfg;
      if (t && t.maxKg && w > 0) m = Math.min(m, Math.max(1, Math.floor(t.maxKg / w + 1e-9)));
      return m;
    }

    /* galerij */
    var track = q('[data-td-st-track]'), dots = qa('[data-td-st-goto]'), curEl = q('[data-td-st-cur]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-td-st-slide]')) : [];
    function goTo(i) {
      if (!track || !slides.length) return;
      i = ((i % slides.length) + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function idx() { return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function goToMedia(id) {
      for (var i = 0; i < slides.length; i++) { if (String(slides[i].getAttribute('data-media-id')) === String(id)) { goTo(i); return; } }
    }
    if (track && dots.length && 'IntersectionObserver' in G) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.intersectionRatio >= 0.6) {
            var i = parseInt(en.target.getAttribute('data-td-st-slide'), 10);
            dots.forEach(function (d) { d.classList.toggle('is-on', parseInt(d.getAttribute('data-td-st-goto'), 10) === i); });
            if (curEl) curEl.textContent = i;
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-td-st-goto'), 10) - 1); }); });
    var prev = q('[data-td-st-prev]'), next = q('[data-td-st-next]');
    if (prev) prev.addEventListener('click', function () { goTo(idx() - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx() + 1); });

    /* alles tekenen vanuit de staat */
    function render(scrollGallery) {
      var c = cur(); S.k = c.k; S.v = c.v;
      var qmax = qmaxFor(c.w);
      S.qty = Math.max(1, Math.min(qmax, parseInt(S.qty, 10) || 1));
      if (numEl) { numEl.value = S.qty; numEl.max = qmax; }
      if (qtyEl) qtyEl.value = S.qty;
      if (vidEl) { vidEl.value = c.id; vidEl.disabled = !c.a; }
      var disc = discOf(S.qty), tot = c.p * S.qty - disc;
      var set = function (sel, txt) { qa(sel).forEach(function (e) { e.textContent = txt; }); };
      set('[data-td-st-price]', fmtMoney(tot));
      set('[data-td-st-unit]', S.qty === 1 ? (c.w ? 'per bigbag van ' + fmtKg(c.w) : 'per bigbag') : 'voor ' + S.qty + ' bigbags' + (c.w ? ' van ' + fmtKg(c.w) : '') + ' (' + S.qty + ' × ' + fmtMoney(c.p) + (disc ? ', min ' + fmtMoney(disc) + ' korting' : '') + ')');
      tierBtns.forEach(function (b) {
        var i = parseInt(b.getAttribute('data-td-st-tier'), 10), on = i === S.qty;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = i > qmax;
        var pe = b.querySelector('[data-td-st-tpr]'), ke = b.querySelector('[data-td-st-tkg]');
        if (pe) pe.textContent = fmtMoney(c.p * i - discOf(i));
        if (ke) ke.textContent = c.w ? (i > 1 ? 'samen ' : '') + fmtKg(c.w * i) : '';
      });
      if (moreBtn) {
        var more = S.qty > tiersN;
        moreBtn.classList.toggle('is-on', more); moreBtn.setAttribute('aria-pressed', more ? 'true' : 'false');
        moreBtn.disabled = qmax <= tiersN;
        if (stepRow) stepRow.hidden = !more;
      }
      set('[data-td-st-ton]', c.w ? fmtMoney(c.p * 1000 / c.w) + ' per ton' : '');
      set('[data-td-st-total]', fmtMoney(tot));
      set('[data-td-st-kg]', c.w ? fmtKg(c.w * S.qty) : '');
      set('[data-td-st-slabel]', S.qty + ' × ' + (c.w ? fmtKg(c.w) : 'bigbag'));
      qa('[data-td-st-step]').forEach(function (b) {
        var d = parseInt(b.getAttribute('data-td-st-step'), 10);
        b.disabled = (d < 0 && S.qty <= 1) || (d > 0 && S.qty >= qmax);
      });
      qa('[data-td-st-k]').forEach(function (b) {
        var on = b.getAttribute('data-td-st-k') === S.k;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var best = null, cards = qa('[data-td-st-v]');
      cards.forEach(function (b) {
        var vv = b.getAttribute('data-td-st-v'), x = pick(S.k, vv), on = vv === S.v;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !x || !x.a;
        var pe = b.querySelector('[data-td-st-vpr]'), te = b.querySelector('[data-td-st-vton]'), bd = b.querySelector('[data-td-st-badge]');
        if (pe) pe.textContent = x ? fmtMoney(x.p) : '';
        if (te) te.textContent = (x && x.w) ? fmtMoney(x.p * 1000 / x.w) + ' per ton' : '';
        if (bd) bd.hidden = true;
        if (x && x.a && x.w) {
          var t = x.p / x.w;
          if (!best || t < best.t - 1e-9) best = { el: b, t: t, n: 1 }; else if (Math.abs(t - best.t) < 1e-9) best.n++;
        }
      });
      if (showBest && best && cards.length > 1 && best.n === 1) { var bd2 = best.el.querySelector('[data-td-st-badge]'); if (bd2) bd2.hidden = false; }
      if (scrollGallery && c.m != null) goToMedia(c.m);
      try { var u = new URL(location.href); u.searchParams.set('variant', c.id); history.replaceState(null, '', u); } catch (e) {}
      var atc = q('[data-td-st-atc]'); if (atc) atc.disabled = !c.a;
      qa('[data-td-st-restrict]').forEach(function (e) { e.hidden = !(c.w >= (parseFloat(e.getAttribute('data-rkg')) || Infinity)); });
      notify();
    }
    function setK(k) {
      var nv = pick(k, S.v);
      if (!nv || !nv.a) {
        nv = null;
        V.forEach(function (x) { if (!nv && x.k === k && x.a) nv = x; });
        V.forEach(function (x) { if (!nv && x.k === k) nv = x; });
      }
      if (!nv) return;
      S.k = nv.k; S.v = nv.v; render(true);
    }
    function setV(v) { if (pick(S.k, v)) { S.v = v; render(false); } }

    qa('[data-td-st-k]').forEach(function (b) { b.addEventListener('click', function () { setK(b.getAttribute('data-td-st-k')); }); });
    qa('[data-td-st-v]').forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) setV(b.getAttribute('data-td-st-v')); }); });
    qa('[data-td-st-step]').forEach(function (b) {
      b.addEventListener('click', function () { S.qty = (parseInt(numEl.value, 10) || 1) + parseInt(b.getAttribute('data-td-st-step'), 10); render(false); });
    });
    if (numEl) numEl.addEventListener('change', function () { S.qty = parseInt(numEl.value, 10) || 1; render(false); });
    tierBtns.forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) { S.qty = parseInt(b.getAttribute('data-td-st-tier'), 10) || 1; render(false); } }); });
    if (moreBtn) moreBtn.addEventListener('click', function () { if (moreBtn.disabled) return; if (!(S.qty > tiersN)) S.qty = tiersN + 1; render(false); if (stepRow) stepRow.hidden = false; });

    /* sticky balk */
    var sticky = q('[data-td-st-sticky]'), atcBtn = q('[data-td-st-atc]');
    if (sticky && atcBtn && 'IntersectionObserver' in G) {
      new IntersectionObserver(function (entries) {
        var en = entries[0], passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', passed); sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      }, { threshold: 0 }).observe(atcBtn);
      var sbtn = q('[data-td-st-sticky-btn]');
      if (sbtn) sbtn.addEventListener('click', function () {
        var f = root.querySelector('form[data-type="add-to-cart-form"]');
        if (!f) return;
        if (typeof f.requestSubmit === 'function') f.requestSubmit(); else atcBtn.click();
      });
    }

    /* toegang voor de rekenhulp */
    TD.main = {
      root: root, V: V, pk: pk, pv: pv,
      state: function () { return { k: S.k, v: S.v, qty: S.qty, variant: cur() }; },
      disc: discOf,
      choose: function (o) {
        if (o.k != null && o.k !== S.k) { var nv = pick(o.k, o.v != null ? o.v : S.v) || null; if (!nv) { V.forEach(function (x) { if (!nv && x.k === o.k) nv = x; }); } if (nv) { S.k = nv.k; S.v = nv.v; } }
        if (o.v != null && pick(S.k, o.v)) S.v = o.v;
        if (o.qty) S.qty = o.qty;
        render(o.k != null);
      },
      focusBuy: function () { var a = q('[data-td-st-atc]'); if (a && a.scrollIntoView) a.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    };
    render(false);
  }

  /* ---------- rekenhulp ---------- */
  function initCalc(root) {
    if (root.__tds) return;
    root.__tds = true;
    var q = function (s) { return root.querySelector(s); };
    var vm = parseFloat(root.getAttribute('data-vm')) || 1600;
    var cm0 = parseFloat(root.getAttribute('data-cm')) || 5;
    var reserve = parseFloat(root.getAttribute('data-reserve')) || 0;
    var m2In = q('[data-td-st-m2in]'), lIn = q('[data-td-st-lin]'), bIn = q('[data-td-st-bin]'), cmIn = q('[data-td-st-cmin]'), out = q('[data-td-st-calcout]'), opts = q('[data-td-st-opts]'), ksel = q('[data-td-st-ksel]');
    if (!m2In || !cmIn || !out || !opts) return;
    var lastSig = '', mode = (lIn && bIn) ? 'lb' : 'm2';
    function dn(el) { var n = parseFloat(String(el && el.value || '').replace(',', '.')); return n > 0 ? n : 0; }
    function nl(x) { return String(Math.round(x * 10) / 10).replace('.', ','); }
    function run() {
      var l = dn(lIn), bw = dn(bIn), a = mode === 'lb' ? l * bw : dn(m2In), cm = parseFloat(cmIn.value) || cm0;
      if (!(a > 0)) { lastSig = ''; opts.innerHTML = ''; out.textContent = mode === 'lb' ? 'Vul je lengte en breedte in.' : 'Vul je oppervlak in.'; return; }
      var m3 = a * cm / 100 * (1 + reserve / 100), need = m3 * vm;
      var head = 'Voor ' + (mode === 'lb' ? nl(l) + ' × ' + nl(bw) + ' m (' + nl(a) + ' m²)' : nl(a) + ' m²') + ' op ' + String(cm).replace('.', ',') + ' cm heb je ± ' + fmtKg(need) + ' nodig (± ' + m3.toFixed(2).replace('.', ',') + ' m³).';
      var m = TD.main;
      if (!m) { lastSig = ''; opts.innerHTML = ''; out.textContent = head; return; }
      var st = m.state();
      var list = m.V.filter(function (x) { return !m.pk || x.k === st.k; });
      var rows = calcOptions(need, list, getCfg().maxKg, m.disc);
      /* alleen opnieuw tekenen bij een andere uitkomst: anders vervangt de blur van het m²-veld de knop onder je vinger en gaat de tik op "Kies" verloren */
      var sig = head + '|' + st.k + '|' + rows.map(function (r) { return r.ref.v + ':' + r.qty + ':' + r.total + (r.best ? '*' : ''); }).join(',');
      if (sig === lastSig) return;
      lastSig = sig; opts.innerHTML = '';
      if (!rows.length) { out.textContent = head + ' Dat is meer dan we in één levering brengen: neem contact met ons op.'; return; }
      out.textContent = head;
      rows.forEach(function (r) {
        var d = document.createElement('div');
        d.className = 'tds-opt' + (r.best ? ' is-best' : '');
        d.innerHTML = '<span><b>' + r.qty + ' × ' + esc(fmtKg(r.ref.w)) + '</b><small>samen ' + esc(fmtKg(r.kg)) + ' · ' + esc(fmtMoney(r.total)) + (r.best ? ' · voordeligste keuze' : '') + '</small></span>';
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tds-opt-btn'; b.textContent = 'Kies';
        b.addEventListener('click', function () { m.choose({ v: r.ref.v, qty: r.qty }); if (root.tagName === 'DETAILS') root.open = false; m.focusBuy(); });
        d.appendChild(b); opts.appendChild(d);
      });
    }
    function sync() {
      var m = TD.main;
      if (ksel && m) { var st = m.state(); if (ksel.value !== st.k) ksel.value = st.k; }
      run();
    }
    [m2In, lIn, bIn, cmIn].forEach(function (el) { if (el) el.addEventListener('input', run); });
    var modeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-td-st-mode]')), panes = Array.prototype.slice.call(root.querySelectorAll('[data-td-st-pane]'));
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-td-st-mode');
        modeBtns.forEach(function (o) { var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        panes.forEach(function (pn) { pn.hidden = pn.getAttribute('data-td-st-pane') !== mode; });
        run();
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-td-st-cmstep]'), function (b) {
      b.addEventListener('click', function () { cmIn.value = Math.max(1, Math.min(30, (parseFloat(cmIn.value) || cm0) + parseInt(b.getAttribute('data-td-st-cmstep'), 10))); run(); });
    });
    if (ksel) ksel.addEventListener('change', function () { if (TD.main) TD.main.choose({ k: ksel.value }); });
    TD.onState(sync);
    run();
  }

  TD.scan = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-td-st-main]'), initMain);
    Array.prototype.forEach.call(document.querySelectorAll('[data-td-st-calc]'), initCalc);
  };
  TD.scan();
  document.addEventListener('shopify:section:load', TD.scan);
})(typeof window !== 'undefined' ? window : this);
